import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';

type Props = {
  description: string;
  total: number;
  completed?: number;
};

const ReportCard: React.FC<Props> = ({ completed, description, total }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.circle}>
        <Typography className={classes.circleContent}>
          {completed !== undefined ? `${completed}/${total}` : total}
        </Typography>
      </Box>
      <Typography className={classes.description}>{description}</Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  description: {
    color: '#fff',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(28),
    fontFamily: FONT_GSS_FUTURA_BOLD,
    padding: '12px 0',
  },
  circle: {
    marginTop: `-${remCalc(50)}`,
    borderRadius: '50%',
    width: remCalc(172),
    height: remCalc(172),
    backgroundColor: '#fff',
    border: '6px solid #cd470f',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleContent: {
    fontSize: theme.typography.pxToRem(30),
    lineHeight: theme.typography.pxToRem(45),
    fontFamily: FONT_GSS_FUTURA_BOLD,
  },
  container: {
    height: remCalc(182),
    marginTop: remCalc(50),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    borderRadius: '20px',
    border: '6px solid #cd470f',
    backgroundColor: '#b33e0c',
  },
}));

export default ReportCard;
